import { render } from "./CheckoutPage.vue?vue&type=template&id=a54d593e&scoped=true"
import script from "./CheckoutPage.vue?vue&type=script&lang=js"
export * from "./CheckoutPage.vue?vue&type=script&lang=js"

import "./CheckoutPage.vue?vue&type=style&index=0&id=a54d593e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a54d593e"]])

export default __exports__